var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBankers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "80px",
    viewBox: "0 0 66 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Bankers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Bankers",
    transform: "translate(-0.503500, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OvalFrame_Gold_wBlue",
    transform: "translate(0.820000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1A4480",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#B7AC82",
    cx: 32.5,
    cy: 32.5,
    r: 29.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(13.820000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 13.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#FFFFFF",
    x: 3.5,
    y: 4,
    width: 4,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#B7AC82",
    strokeWidth: 2,
    x: 0,
    y: 17,
    width: 11,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#B7AC82",
    strokeWidth: 2,
    x: 1,
    y: 0,
    width: 9,
    height: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(14.000000, 13.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#FFFFFF",
    x: 3.5,
    y: 4,
    width: 4,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#B7AC82",
    strokeWidth: 2,
    x: 0,
    y: 17,
    width: 11,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#B7AC82",
    strokeWidth: 2,
    x: 1,
    y: 0,
    width: 9,
    height: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(27.000000, 13.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#FFFFFF",
    x: 3.5,
    y: 4,
    width: 4,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#B7AC82",
    strokeWidth: 2,
    x: 0,
    y: 17,
    width: 11,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#B7AC82",
    strokeWidth: 2,
    x: 1,
    y: 0,
    width: 9,
    height: 8
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.5,
    y: 36.5,
    width: 38,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#B7AC82",
    fillRule: "nonzero",
    x: 1,
    y: 13,
    width: 37,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-8",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "19.5 1 39 11.0011536 39 15 0 15 0 11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(16.000000, 0.000000)",
    fill: "#B7AC82",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 11,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.596,
    y: 11.6953037
  }, "$"))))), /*#__PURE__*/React.createElement("path", {
    d: "M4.692,79.296 L4.692,70.168 L7.814,70.168 C9.718,70.168 11.188,70.686 11.188,72.436 C11.188,73.248 10.712,74.13 9.648,74.41 L9.648,74.466 C10.95,74.704 11.636,75.39 11.636,76.608 C11.636,78.47 10.068,79.296 8.08,79.296 L4.692,79.296 Z M6.764,73.85 L7.716,73.85 C8.724,73.85 9.172,73.416 9.172,72.73 C9.172,72.044 8.696,71.764 7.744,71.764 L6.764,71.764 L6.764,73.85 Z M6.764,77.7 L7.912,77.7 C9.032,77.7 9.62,77.28 9.62,76.454 C9.62,75.656 9.046,75.306 7.912,75.306 L6.764,75.306 L6.764,77.7 Z M15.066,75.516 L17.026,75.516 L16.802,74.676 C16.55,73.766 16.312,72.688 16.06,71.736 L16.004,71.736 C15.794,72.702 15.542,73.766 15.29,74.676 L15.066,75.516 Z M18.006,79.296 L17.446,77.126 L14.646,77.126 L14.086,79.296 L11.986,79.296 L14.856,70.168 L17.32,70.168 L20.19,79.296 L18.006,79.296 Z M21.142,79.296 L21.142,70.168 L23.256,70.168 L25.636,74.704 L26.546,76.72 L26.602,76.72 C26.504,75.754 26.336,74.466 26.336,73.388 L26.336,70.168 L28.296,70.168 L28.296,79.296 L26.182,79.296 L23.802,74.746 L22.906,72.758 L22.85,72.758 C22.948,73.766 23.116,74.984 23.116,76.062 L23.116,79.296 L21.142,79.296 Z M30.438,79.296 L30.438,70.168 L32.51,70.168 L32.51,73.906 L32.552,73.906 L35.282,70.168 L37.536,70.168 L34.778,73.808 L38.054,79.296 L35.786,79.296 L33.574,75.446 L32.51,76.846 L32.51,79.296 L30.438,79.296 Z M39.02,79.296 L39.02,70.168 L44.746,70.168 L44.746,71.904 L41.092,71.904 L41.092,73.738 L44.2,73.738 L44.2,75.46 L41.092,75.46 L41.092,77.56 L44.886,77.56 L44.886,79.296 L39.02,79.296 Z M48.736,71.806 L48.736,74.368 L49.786,74.368 C50.864,74.368 51.452,73.906 51.452,73.01 C51.452,72.114 50.864,71.806 49.786,71.806 L48.736,71.806 Z M53.916,79.296 L51.606,79.296 L49.856,76.006 L48.736,76.006 L48.736,79.296 L46.664,79.296 L46.664,70.168 L49.954,70.168 C51.886,70.168 53.482,70.84 53.482,73.01 C53.482,74.354 52.824,75.208 51.858,75.642 L53.916,79.296 Z M54.49,78.148 L55.68,76.734 C56.324,77.294 57.164,77.686 57.92,77.686 C58.774,77.686 59.194,77.35 59.194,76.804 C59.194,76.23 58.676,76.048 57.878,75.712 L56.702,75.208 C55.75,74.83 54.854,74.046 54.854,72.716 C54.854,71.204 56.212,70 58.102,70 C59.152,70 60.258,70.42 61.042,71.204 L60.006,72.506 C59.404,72.044 58.83,71.778 58.102,71.778 C57.402,71.778 56.94,72.086 56.94,72.604 C56.94,73.164 57.542,73.36 58.34,73.682 L59.502,74.158 C60.608,74.606 61.308,75.348 61.308,76.636 C61.308,78.148 60.048,79.464 57.878,79.464 C56.688,79.464 55.428,79.016 54.49,78.148 Z",
    id: "BANKERS",
    fill: "#1A4480",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBankers);
export default __webpack_public_path__ + "static/media/Icon_Bankers.25f58ec468d28b93d8fd5f3ea5c8eb3f.svg";
export { ForwardRef as ReactComponent };